/**
 * HTTP Methods and Verbs constants and utilities
 */
export const DELETE = 'DELETE';
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const GET = 'GET';
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const HEAD = 'HEAD';
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const OPTIONS = 'OPTIONS';
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const PATCH = 'PATCH';
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const POST = 'POST';
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const PUT = 'PUT';
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const HTTP_VERB_NO_BODY = [GET, HEAD, OPTIONS];
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const HTTP_VERB_WITH_BODY = [PATCH, POST, PUT, DELETE];
/**
 * HTTP Methods and Verbs constants and utilities
 */
export const ALL_HTTP_VERB = [
    DELETE,
    GET,
    HEAD,
    PATCH,
    POST,
    PUT,
    OPTIONS,
];
const post = (body) => ({ verb: POST, body });
const patch = (body) => ({ verb: PATCH, body });
const put = (body) => ({ verb: PUT, body });
const del = (body) => ({ verb: DELETE, body });
const get = { verb: GET };
const head = { verb: HEAD };
const options = { verb: OPTIONS };
/**
 * HttpMethod constructors
 */
export const Method = {
    POST: post,
    PATCH: patch,
    PUT: put,
    GET: get,
    HEAD: head,
    DELETE: del,
    OPTIONS: options,
};
/**
 * Check if a HTTP verb allows body
 */
export const verbAllowsBody = (verb) => HTTP_VERB_WITH_BODY.includes(verb);
/**
 * Check if a HTTP method allows body
 */
export const methodAllowsBody = (method) => verbAllowsBody(method.verb);
